<template>
  <div>
    <div v-if="!dataLoaded">
      <v-progress-circular indeterminate color="primary" class="ret-center-absolute"></v-progress-circular>
    </div>
    <div v-if="dataLoaded" class="ret-cards-wrapper">
      <v-card class="ret-card-new">
        <v-card-title>
          <h3 class="headline">{{ $t('team') }}</h3>
        </v-card-title>
        <v-card-text>
          <users-in
            v-if="item.usersInTeams"
            connection="usersInTeams"
            :item="item"
            :subitems="users"
            v-on:onRemoveUserIn="onRemoveUserIn"
            v-on:onAddUserIn="onAddUserIn"
          ></users-in>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="$router.go(-1)">{{ $t('back') }}</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import displayHelpers from '../helpers/display-helpers.es6'
import itemHelpers from '../helpers/item-helpers.es6'
import UsersIn from '../users/components/users-in.vue'

export default {
  mixins: [displayHelpers, itemHelpers],
  data: function () {
    return {
      model: { name: 'teams' },
      auxModels: [
        { name: 'users' }
      ]
    }
  },
  computed: {
    users () {
      return this.$store.state.items['users']
    }
  },
  methods: {
    // Actions
    onAddUserIn (userId) {
      console.log('onAddUserIn, userId: ' + userId)
      let newUserIn = {
        teamId: this.id,
        userId: userId
      }
      this.$store.dispatch('updateItem', { modelName: 'users-in-teams', item: newUserIn })
        .then(() => {
          // this.save({reRoute: false})  // must save any unsaved content (without re-routing) before storeUpdate
        })
        .then(() => {
          this.storeUpdate()
        })
    },
    onRemoveUserIn (id) { // id of the userIn (not user id)
      console.log('removing user-in')
      this.$store.dispatch('destroyItem', { model: { name: 'users-in-teams' }, id: id })
        .then(() => {
          // this.save({reRoute: false})  // must save any unsaved content (without re-routing) before storeUpdate
        })
        .then(() => {
          this.storeUpdate()
        })
    }
  },
  components: {
    UsersIn
  }
}
</script>
